const getConfig = () => {
  return {
    rowSelection: false,
    scroll: { y: `calc(100vh - 280px)` },
    columns: [
      {
        title: 'SKU名称',
        dataIndex: 'skuName',
        width: 160,
        ellipsis: true,
      },
      {
        title: 'SKU_ID',
        dataIndex: 'skuId',
        width: 180,
      },
      {
        title: '适用产品',
        dataIndex: 'productName',
        width: 160,
        ellipsis: true,
      },
      {
        title: '适用门店',
        dataIndex: 'shopName',
        width: 160,
        ellipsis: true,
        render: (v, record) => record.shopId === '0' ? '通用' : v
      },
      {
        title: '定价客户价',
        dataIndex: 'customerPrice',
        width: 100,
        render: (v) => <div style={{textAlign: 'right'}}>{v?.toLocaleString?.()}</div>,
      },
      {
        title: 'SKU成本价',
        dataIndex: 'costPrice',
        width: 100,
        render: (v) => <div style={{textAlign: 'right'}}>{v?.toLocaleString?.()}</div>,
      },
      {
        title: '定价毛利(%)',
        dataIndex: 'pricingMarginPercent',
        width: 105,
        fixed: 'right',
        render: 'textRender'
      },
      {
        title: '配置毛利(%)',
        dataIndex: 'configuredMarginPercent',
        width: 105,
        fixed: 'right',
        render: 'textRender'
      },
      {
        title: '预警类型',
        dataIndex: 'alertType',
        width: 100,
        fixed: 'right',
        render: 'typeRender'
      },
      {
        title: '操作',
        dataIndex: '#',
        width: 100,
        fixed: 'right',
        render: 'actionRender'
      },
    ],
    search: [
      {
        label: '适用产品',
        name: 'productId',
        itemType: 'custom',
        render: 'searchSelectRender'
      },
      {
        name: 'shopId',
        label: '适用门店',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
      },
      {
        label: 'SKU名称/ID',
        name: 'skuKey'
      },
      {
        label: '预警类型',
        name: 'alertType',
        itemType: 'select',
        data: 'alertTypeEnum',
        key: 'key',
        labelKey: 'description'
      },
      {
        label: '定价毛利范围',
        name: 'pricingMargin',
        itemType: 'custom',
        render: 'rangeRender',
      },
      {
        label: '定价毛利最小',
        name: 'pricingMarginLimit',
        hidden: true,
      },
      {
        label: '定价毛利最大',
        name: 'pricingMarginMax',
        hidden: true,
      },
    ],
    footer: [
      {
        label: '导出',
        itemType: 'custom',
        render: 'exportRender'
      },
      {
        label: '查看配置',
        events: ['onClick:onAdd']
      },
    ],
  }
}

export {getConfig}